import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, DATETIME, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'

export default class extends Resource {
  static name = 'account_costcentre'

  static get fields () {
    return {
      id: new UUID(),
      account: new ITEM(Account),
      name: new STRING(),
      description: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
